import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WebAdminService extends BaseService {
  private baseUrl = '/jobhunting';

  syncDbFromCard(cardId: number): Observable<any> {
    return this.basePut(`${this.baseUrl}/sync-pipe-card/${cardId}`, cardId);
  }

}
